<template>
  <div ref="component">
    <div class="medium-container d-inline" v-if="editMode">
      <medium-editor :text="text" @edit="onEdit" :options="options" custom-tag="div"></medium-editor>
      <a href="javascript:void(0)" @click.stop="applyTextEdit"><i class="fa fa-check"></i></a>
      <a href="javascript:void(0)" @click.stop="editMode = false"><i class="fa fa-times"></i></a>
    </div>
    <div class="d-inline medium-container" v-else>
      <span v-if="(text === '' || text === null) && emptyLabel && editable" v-cloak>
        {{ emptyLabel }}
      </span>
      <div v-html="text" class="d-inline"></div> 
      <a href="javascript:void(0)" v-if="editable"><i class="fa fa-pencil" @click.stop="enableEdit()"></i></a>
    </div>
    <a href="javascript:void(0)" class="d-block" v-b-toggle="'collapse' + id" variant="primary" v-if="noteList.length > 0">Läs mer <i class="fa-angle-down fa"></i></a>
    <b-collapse :id="'collapse' + id" v-if="noteList.length > 0">
      <div class="note-list">
        <b>OBSERVERA</b>
        <div v-for="(note, index) in distinctNoteList" v-bind:key="index">
          <p><b>{{ note.name === '*' ? '*' : '&#9658;'}}</b> {{note.text}} </p>
        </div>
      </div>
    </b-collapse>
    <div v-for="ref in referenceList" v-bind:key="ref.id">
      <b-tooltip class="b-tooltip" :target="ref.id" :title="ref.text"></b-tooltip>
    </div>
    <div v-for="note in noteList" v-bind:key="note.id">
      <b-tooltip :target="note.id" :title="note.text"></b-tooltip>
    </div>
  </div>
</template>

<script>

import vueMediumEditor from 'vue2-medium-editor'
import ReferenceAndNotesExtension from '../components/MediumExtensions/ReferenceAndNotes'
import { startsWith, endsWith, uniqBy, isEqual, isEmpty } from 'lodash'

export default {
  name: 'Editor',
  model: {
    prop: 'text'
  },
  props: {
    text: {
      type: String,
      default: '',
      required: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    applyTextEditCallback: {
      type: Function,
      required: false
    },
    emptyLabel: {
      type: String
    },
    areaKey: {
      type: String,
      default: 'main'
    }
  },
  components: {
    'medium-editor': vueMediumEditor
  },
  data () {
    return {
      id: null,
      editMode: false,
      value: this.text,
      referenceList: [],
      noteList: [],
      options: {
        toolbar: {
          buttons: ['bold', 'italic', 'underline', 'referenceandfootnote']
        }
      }
    }
  },
  mounted () {
    this.id = this._uid
    this.setInitials()
  },
  computed: {
    distinctNoteList () {
      return uniqBy(this.noteList, 'name')
    },
    references () {
      let item = this.$store.getters.references
      if (!item) return ''
      return item || ''
    },
    notes () {
      let item = this.$store.getters.notes
      if (!item) return ''
      return item || ''
    }
  },
  methods: {
    enableEdit () {
      this.value = this.text
      this.editMode = true
    },
    onEdit () {
      // const event = e.event
      // if (event) {
      //   this.value = event.currentTarget.innerHTML
      // }
      this.value = document.querySelector('[data-medium-focused]').innerHTML
    },
    applyTextEdit () {
      this.editMode = false
      if (isEqual(this.text, this.value)) { return }
      // this.value = this.value.replace(new RegExp('<a href=', 'g'), `<a class="reference" href=`)
      this.value = this.value.replace('<p><br></p>', '')
      if (startsWith(this.value, '<p>') && endsWith(this.value, '</p>')) {
        this.value = this.value.substring(3, this.value.length - 4)
      }
      // Remove common tags and then check if text-empty. If so, completely remove content. This to not have garbage/whitespace content that triggers showing headers i view mode for whitespace.
      if (isEmpty(this.value.replace(/<br *\/?>|&nbsp;| |<\/?div>|<\/?p>/g, ''))) {
        this.value = ''
      }
      this.$emit('input', this.value)
      if (this.applyTextEditCallback !== undefined) {
        this.applyTextEditCallback()
      }
      // Clear references and notes in order to trigger a 'refresh' for the b-tooltip component
      this.referenceList = {}
      this.noteList = {}
      this.setInitials()
    },
    setInitials () {
      let _this = this
      setTimeout(function () {
        _this.setReferences()
        _this.setLinks()
        _this.options.extensions = {
          'referenceandfootnote': new ReferenceAndNotesExtension({notes: _this.notes, references: _this.references})
        }
      }, 400)
    },
    setReferences () {
      let tags = this.$refs['component'].getElementsByClassName('reference')
      this.referenceList = []
      for (let i = 0; i < tags.length; i++) {
        const href = tags[i].href.substring(tags[i].href.lastIndexOf('/') + 1)
        const reference = this.$store.getters.referenceByName(href)
        if (reference) {
          const id = this.areaKey + '-ref-' + i
          tags[i].id = id
          tags[i].href = 'javascript:void(0)'
          this.referenceList.push({
            id: this.areaKey + '-ref-' + i,
            a_id: id,
            text: reference.text
          })
        }
      }
    },
    setLinks () {
      this.noteList = []
      let tags = this.$refs['component'].getElementsByClassName('note')
      for (let i = 0; i < tags.length; i++) {
        const href = tags[i].href.substring(tags[i].href.lastIndexOf('/') + 1)
        const note = this.$store.getters.noteByName(href)
        if (note) {
          const id = this.areaKey + '-note-' + i
          tags[i].id = id
          tags[i].href = 'javascript:void(0)'
          this.noteList.push({
            id: this.areaKey + '-note-' + i,
            a_id: id,
            text: note.text,
            name: note.name
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.medium-container {
  .fa {
    color: #7e57c2;
    font-size: 24px;
  }
  [v-cloak] {
    display: none;
  }
  /* border: 1px solid grey;
  padding: 20px; */
  .medium-editor-element {
    // background-color: #f9ebe2;
    border: 1px lightgrey solid;
    border-style: dashed;
  }
}

.medium-editor-toolbar,
.medium-editor-toolbar2 {
  .references-and-notes {
    padding: 10px;
    h3 {
      color: white;
      margin-bottom: 2px;
    }
  }
    li {
      button {
        border-right: 1px solid #ffc7a3;
        &:hover {
          background-color: #ca5000;
        }
      }
      .medium-editor-button-active {
        background-color: #ca5000;
      }
    }
    background-color: #ff6500;
    
  }
  .medium-toolbar-arrow-under:after {    
      border-color: #ff6500 transparent transparent transparent;
      z-index: -1;
  }
  .medium-editor-toolbar-anchor-preview {
    background: #ff6500;
  }
  .medium-toolbar-arrow-over:before {
    border-color: transparent transparent #ff6500 transparent;
  }
  .medium-editor-toolbar-form .medium-editor-toolbar-input {
    background: #ff6500;
  }

  .note-list {
    font-size: smaller;
    margin-top: 10px;
    background-color: $ljusgul;
    padding: 10px;
    border: 1px $grå50 solid;
  }

</style>


